import type { Distance, Point } from "@pdfking/math"
import { FULL_TURN, ZERO_DEGREE } from "@pdfking/math/constants"
import { RecordQ } from "@pdfking/structs"

import type { PathPoint } from "#public"

import { ArcPoints } from "./ArcPoints"

/** The ellipse round `center` of `radius` across and up — the same both ways,
 * a circle: four anchors, each with both handles, to plot with `closed:
 * true`. */
export const Oval = (center: Point<Distance>, radius: Point<Distance> | Distance): PathPoint[] => {
  const { x, y } = RecordQ(radius) ? radius : { x: radius, y: radius }
  const arc = ArcPoints(center, x, ZERO_DEGREE, FULL_TURN, y)
  const [first, last] = [arc[0]!, arc[arc.length - 1]!]
  return [{ ...first, before: last.before }, ...arc.slice(1, -1)]
}
